<template>
    <div>
        <v-navigation-drawer
                v-model="drawer"
                :clipped="$vuetify.breakpoint.lgAndUp"
                fixed
                class="deep-purple accent-3"
                dark
                app
        >
            <v-layout column align-center>
                <v-flex class="my-5">
                    <template v-if="user">
                        <h1 class="white--text">{{user.name}}</h1>
                    </template>
                </v-flex>
            </v-layout>

            <v-list v-if="user">
                <template v-for="link in links">
                    <v-list-tile
                            v-if="checkIfLinkIsAllowed(link.permission)"
                            active-class="deep-purple darken-4"
                            :key="link.text"
                            router :to="link.route"
                    >
                        <v-list-tile-action>
                            <v-icon >{{ link.icon}}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ link.text}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-navigation-drawer>

        <v-toolbar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                color="grey darken-4"
                dark
                app
                flat
                fixed>

            <v-toolbar-side-icon @click.stop="drawer = !drawer"/>

            <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
                <span class="hidden-xs-only">CONTAINER APP</span>
            </v-toolbar-title>

            <v-spacer/>

            <v-btn @click="logout" flat color="white" >
                <span>Sign out</span>
                <v-icon right>exit_to_app</v-icon>
            </v-btn>

        </v-toolbar>

    </div>
</template>

<script>
    export default {
        name: "Navigation",
        props: ['links', 'user'],
        data: () => ({
            dialog: false,
            drawer: null,
        }),
        methods: {
            logout () {
                this.$store.dispatch('destroyToken');
            },
            checkIfLinkIsAllowed(linkPermission){
                if (linkPermission === ''){
                    return true
                }
                return this.user.permissions.includes(linkPermission);
            }
        }
    }
</script>

<style scoped>

</style>